import axios from "@/services/axios";
import { getPaginationValues } from "@/utils/pagination-helper";
import { computed, reactive } from "vue";

const state = reactive({
  selectedResearchOrganization: {} as any,
  group: [],
});

export default function ResearchOrganizationRepositoryAPI() {
  async function load(): Promise<void> {
    const data = await axios
      .get(`api/v1/ResearchOrganization?PageNumber=0&PageSize=50`)
      .then((response: any) => {
        return response.data;
      });
    state.group = data;
  }

  const loadItems = (data: any): void => {
    axios
      .get(
        `api/v1/ResearchOrganization?PageNumber=${data.lazyParams.page}&PageSize=${data.lazyParams.rows}&Keyword=${data.keywords}`
      )
      .then((response: any) => {
        data.organizationGroup = response.data;
        data.lazyParams = getPaginationValues(response.headers);
        data.dataLoading = false;
      })
      .catch(() => (data.dataLoading = false));
  };

  const loadItem = (data: any, id: string): void => {
    axios
      .get(`api/v1/ResearchOrganization/${id}/detail`)
      .then((response: any) => {
        data.organizationGroup.push(response.data);
        data.dataLoading = false;
      })
      .catch(() => (data.dataLoading = false));
  };

  const setResearchOrganization = (selected: any) => {
    state.selectedResearchOrganization = selected;
  };

  return {
    setResearchOrganization,
    getSelectedResearchOrganization: computed(
      () => state.selectedResearchOrganization
    ),
    loadResearchOrganizationGroup: load,
    researchOrganizationState: state,
    loadItems,
    loadItem,
  };
}
